import { useTranslation } from "react-i18next";
import { setLanguage, type Lang } from "@project/lib/i18n-config";

export function useI18n() {
  const { t, i18n } = useTranslation();
  const lang: Lang = i18n.language?.startsWith("gu") ? "gu" : "en";
  return { t, lang, setLang: setLanguage, i18n };
}

export type { Lang };
